import React from 'react';
import { CONTACT } from '../data/products';

export default function WhatsAppFloat() {

  return (
    <a
      href={`https://wa.me/${CONTACT.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 end-6 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-2xl"
    >
      {/* WhatsApp SVG icon */}
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.49.65 4.83 1.79 6.86L2 30l7.34-1.76A13.94 13.94 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 2c6.627 0 12 5.373 12 12S22.627 28 16 28a11.94 11.94 0 01-5.98-1.6l-.42-.25-4.36 1.05 1.08-4.25-.27-.44A11.94 11.94 0 014 16C4 9.373 9.373 4 16 4zm-3.3 5.5c-.22 0-.57.08-.87.4-.3.33-1.14 1.11-1.14 2.71s1.17 3.14 1.33 3.36c.17.22 2.27 3.62 5.6 4.93 2.77 1.09 3.34.87 3.94.82.6-.06 1.94-.8 2.21-1.56.28-.77.28-1.43.2-1.56-.08-.14-.3-.22-.63-.38-.33-.17-1.94-.96-2.24-1.07-.3-.11-.52-.17-.74.17-.22.33-.85 1.07-1.04 1.29-.2.22-.39.25-.72.08-.33-.17-1.4-.52-2.67-1.65-.98-.88-1.65-1.97-1.84-2.3-.2-.33-.02-.51.14-.67.15-.15.33-.39.5-.58.16-.2.22-.33.33-.55.11-.22.06-.42-.03-.58-.08-.17-.72-1.79-1.01-2.44-.25-.58-.52-.5-.72-.51h-.61z"/>
      </svg>

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    </a>
  );
}
